export default __webpack_public_path__ + "static/media/codice-etico.8f851898.png";